import { ArrowUp, Mail, MapPin, Phone } from "lucide-react";
import { BUSINESS, NAV, SERVICES } from "@/lib/content";
import { scrollToId } from "@/lib/scroll";
import LegalDialog from "@/components/site/LegalDialog";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative overflow-hidden bg-[#020408] border-t border-cyan-300/10 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <img src="/assets/logo-full.png" alt="UNDERCLEAN - Propreté et services" className="h-28 w-28 mix-blend-lighten" />
            <p className="mt-5 max-w-xs text-sm text-slate-400 leading-relaxed">
              Nettoyage de bureaux, locaux professionnels, bâtiments, vitrerie et remise en état.
            </p>
          </div>
          <div className="md:col-span-2">
            <div className="font-mono-uc text-xs uppercase tracking-[0.2em] text-cyan-300">Navigation</div>
            <ul className="mt-5 space-y-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button onClick={() => scrollToId(n.id)} className="text-sm text-slate-300 hover:text-white transition-colors duration-300" data-testid={`footer-link-${n.id}`}>
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono-uc text-xs uppercase tracking-[0.2em] text-cyan-300">Prestations</div>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s.key} className="text-sm text-slate-300">{s.title}</li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-3">
            <div className="font-mono-uc text-xs uppercase tracking-[0.2em] text-cyan-300">Contact</div>
            <ul className="mt-5 space-y-4 text-sm text-slate-300">
              <li>
                <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 hover:text-cyan-300 transition-colors duration-300 break-all" data-testid="footer-email-link">
                  <Mail className="h-4 w-4 shrink-0" /> {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-3" data-testid="footer-phone"><Phone className="h-4 w-4 shrink-0" /> {BUSINESS.phone}</li>
              <li className="flex items-center gap-3" data-testid="footer-address"><MapPin className="h-4 w-4 shrink-0" /> {BUSINESS.address}</li>
            </ul>
          </div>
        </div>

        <div className="mt-20 select-none font-display font-extrabold text-brand text-[13.5vw] lg:text-[11.5rem] leading-[0.8] tracking-tighter opacity-90" aria-hidden>
          UNDERCLEAN
        </div>

        <div className="mt-10 flex flex-col gap-5 border-t border-white/10 pt-8 md:flex-row md:items-center md:justify-between">
          <div className="text-xs text-slate-400 leading-relaxed" data-testid="footer-legal-summary">
            © {year} {BUSINESS.name} - {BUSINESS.owner}, entrepreneur individuel. SIRET : {BUSINESS.siret}.
            <br className="sm:hidden" /> TVA non applicable, art. 293 B du CGI.
          </div>
          <div className="flex items-center gap-6">
            <LegalDialog />
            <button
              onClick={() => scrollToId("top")}
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-white hover:bg-cyan-300 hover:text-[#050811] transition-colors duration-300"
              aria-label="Haut de page"
              data-testid="footer-back-to-top"
            >
              <ArrowUp className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
